import CaseStore from "./CaseStore";

const caseStore: CaseStore = new CaseStore();

export default caseStore;
